<template>
  <div>
    <mainHeader class="mainHeader"></mainHeader>
    <div class="wrapper">
      <load v-if="loadingPage"></load>
      <div v-if="SolutionFlag" class="cssFindSolution">温馨提示：如页面无法显示，请<span class="checkHere" @click="priceTipClick">点击这里</span></div>
      <InfoView :show="showInfoView" type="4" @infoViewClick="infoViewClick"></InfoView>
     <!-- <div v-if="SolutionDialogFlag" class="cssMask"></div>
      <div v-if="SolutionDialogFlag" class="cssSolutionDialog">
        <i class="Close clearfix" @click="CloseDialog"></i>
        <div class="cssDialogBody">
          <p class="cssTips">由于safari浏览器的最新安全策略，导致第三方网站无法正常显示</p>
          <p class="cssTips">如出现合同签署页面、合同预览页面无法打开的情况，请按以下步骤设置浏览器：</p>
          <p class="cssTips">1：进入“设置”，找到safari并点击进入</p>
          <p class="cssTips">2：找到“阻止跨网站跟踪”选项，并关闭</p>
          <p class="cssTips">3：回到浏览器，并刷新页面</p>
          <div class="cssScrollArea">
            <img class="ImgurlOne" :src='ImgurlOne'>
            <img class="ImgurlTwo" :src='ImgurlTwo'>
          </div>
        </div>
      </div> -->
      <iframe :class="['Frame',{'none':SolutionFlag === false}]" id="contractInfo" :src="InnerHtml"></iframe>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui'
import mainHeader from '../view/header'
import load from '../components/loading'
import InfoView from '../components/info-view'
export default {
  components: {
    load,
    mainHeader,
    InfoView
  },
  name: 'CompanyAuthChecking',
  data () {
    return {
      showInfoView: false,
      loadingPage: false,
      solutionid: this.$route.query.planId || 667, // 667为测试数据
      InnerHtml: '',
      SolutionFlag: false,
      SolutionDialogFlag: false
    }
  },
  methods: {
    creat () {
      let _this = this
      this.utils.POST(
        this.accountUrl + '/ESign/createSign',
        {
          solutions_id: this.solutionid
        },
        resj => {
          _this.utils.POST(
            _this.accountUrl + '/ESign/getDocUrl',
            {
              solutions_id: _this.solutionid
            },
            resj => {
              _this.InnerHtml = resj.data.shortUrl
              _this.loadingPage = false
              _this.SolutionFlag = false
              if (_this._isMobile) {
                let Flag = localStorage.getItem('settingFlag')
                // let Flag = null
                if (_this.utils.myBrowser() === 'Safari' && Flag === null) {
                  _this.SolutionFlag = true
                  localStorage.setItem('settingFlag', true)
                }
              }
            }
          )
        }
      )
    },
    showSolution: function () {
      this.SolutionDialogFlag = true
      document.body.style.overflow = 'hidden'
    },
    CloseDialog: function () {
      this.SolutionDialogFlag = false
      document.body.style.overflow = 'auto'
    },

    priceTipClick: function () {
      this.showInfoView = true
    },
    infoViewClick: function () {
      this.showInfoView = false
    },
    // getOpenUrl () {
    //   console.log('请求接口')
    //   let _this = this
    //   this.utils.POST(_this.accountUrl + '/ESign/getDocUrl?solutions_id=' + this.solutionid, null, function (res) {
    //     // console.log('res==' + res)
    //     _this.InnerHtml = res.data.url
    //
    //   })
    // },

    getStatus () {
      let _this = this
      _this.utils.GET(
        _this.accountUrl +
          '/zxOrder/consultingOrderStatus?sId=' +
          _this.solutionid,
        function (res) {
          if (res.data.contract_online_status === '签署完成') {
            clearTimeout(_this.goStatus)
            _this.$router.push({
              path: '/emergency-detail',
              query: {
                planId: _this.solutionid
              }
            })
          } else {
            _this.goStatus = setTimeout(() => {
              _this.getStatus()
            }, 5000)
          }
        }
      )
    }
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再签署合同！')
        _this.$router.push({path: 'login', query: {back: 1}})
      } else {
        _this.loadingPage = true
        _this.creat()
        _this.getStatus()
      }
    })
  },
  destroyed () {
    console.log('销毁计时器')
    clearTimeout(this.goStatus)
  }
  // watch: {
  //   $route (to, from) {
  //     clearTimeout(this.goStatus)
  //   }
  // }
}
</script>
<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}

.wrapper {
  background-color: #f4f4f4;
  /*height: 100%;*/
  margin-top: 55px;
  padding-bottom: 65px;
}
.Name {
  width: 100%;
  height: 100%;
  position: fixed;
}
.cssFindSolution {
  top: 0px;
  height: 25px;
  width: 100%;
  font-size: 14px;
  line-height: 23px;
  background: #ffb4b4;
  color: #c41335;
  text-align: center;
  z-index: 15;
}
.cssFindSolution .checkHere {
  position: relative;
}
.cssFindSolution .checkHere::after {
  content: "";
  position: absolute;
  height: 2px;
  width: 56px;
  background: #c41335;
  top: 19px;
  left: 0;
}
.cssMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.4;
  overflow: hidden;
  z-index: 20;
}
.cssSolutionDialog {
  position: fixed;
  top: calc(50% - 250px);
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 250px;
  height: 500px;
  background: #ffffff;
  overflow: hidden;
  z-index: 20;
}
.cssSolutionDialog .Close {
  display: inline-block;
  font-style: normal;
  font-size: 16px;
  height: 20px;
  width: 20px;
  background: url("../assets/close.png") no-repeat center center;
  background-size: cover;
  float: right;
  margin: 5px 5px 0 0;
}
.cssSolutionDialog .cssDialogBody {
  margin-top: 30px;
  padding: 0 15px 0 15px;
}
.cssSolutionDialog .cssTips {
  text-indent: 16px;
  line-height: 20px;
  font-size: 14px;
  margin-bottom: 10px;
}
.cssSolutionDialog .cssScrollArea {
  height: 370px;
  overflow: scroll;
}
.cssSolutionDialog .ImgurlOne,
.cssSolutionDialog .ImgurlTwo {
  width: 100%;
}
.Frame {
  position: absolute;
  top: 80px;
  width: 100%;
  height: 100%;
  border: none;
}
.Frame.none {
  top: 55px;
  height: calc(100% - 55px);
}
</style>



// WEBPACK FOOTER //
// src/view/company-auth-in-phone.vue